import { getBaseUrl } from './baseUrl'

// The log endpoint is owned by the client's own logging concern, so it is kept local here to avoid
// a circular @core/http-client <-> @core/api package dependency (the url registry lives in @core/api).
const LOG_ENDPOINT = 'log'

/**
 * Plain `fetch`, not `httpClient`: the client's `beforeError` hook is `logError`, which calls this —
 * posting through it makes a failing log request log itself.
 */
export const sendLog = (message: string) => {
    const base = getBaseUrl().replace(/\/$/, '')

    return fetch(base ? `${base}/${LOG_ENDPOINT}` : LOG_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message }),
    }).catch(() => undefined)
}
